module.exports = __webpack_public_path__ + "img/t1-purple.13c5b4cc.png";